import { defineMessages } from 'utils/intl';

export default defineMessages({
  metaDescription:
    'Dla firm - {filters} - wiele konfiguracji na {appName} | Dystrybucja PL, natychmiastowa wysyłka, dostawa 0 PLN',
  searchResults: 'Wyniki wyszukiwania: „{searchName}"',
  lackOfExactMatch: 'Brak ścisłego dopasowania „{searchName}"',
  didYouMean: 'Czy chodziło o „{correctedQuery}"?',
  lackOfResults: 'Brak wyników dla frazy „{searchName}"',
  seeSuggestedResults: 'Zobacz wyniki zbliżone:',
  notFoundResults: 'Nie znaleźliśmy produktów dla frazy „{searchName}"',
  notFoundResultsWithoutQuery: 'Nie znaleźliśmy produktów spełniających kryteria',
  pageNo: 'strona {page}',
  onlyAvailable: 'tylko dostępne',
});
